// extracted by mini-css-extract-plugin
module.exports = {"tagIcon":"CommentContainer-tagIcon-1JJjH","answeredTag":"CommentContainer-answeredTag-3YS_z","removeAnswered":"CommentContainer-removeAnswered-24ymK"};